import { createBrowserRouter } from 'react-router';
import { routes } from './routes';

/**
 * Browser router. The route table itself lives in routes.tsx so the
 * prerenderer uses the SAME definition — see the note there.
 */
export const router = createBrowserRouter(routes);

export { RequireAuth } from './features/auth/RequireAuth';
